// Contenido del aviso cuando lo que está configurado en Negocio no deja facturar: la firma
// electrónica (estado 602) o una dirección que el SRI exige (604, `establishmentGuard`).
//
// El backend ya dice el motivo exacto: firma expirada, archivo y contraseña que no abren, o qué
// establecimiento no tiene dirección. Antes la pantalla lo tapaba con un texto fijo que siempre
// culpaba a la contraseña, así que quien tenía la firma vencida la reescribía sin resultado.
// `action` le pide al diálogo el botón «Ir a Negocio» y dice a qué sección lleva (?focus=).
export const CERTIFICATE_FALLBACK = 'Su certificado o la contraseña del certificado no es válida.';
export const ADDRESS_FALLBACK = 'A un establecimiento le falta la dirección. Complétala en Negocio › Establecimientos y puntos de emisión.';

export function certificateError(response, isNewSale) {
    const reason = response && typeof response.error === 'string' ? response.error.trim() : '';
    const missingAddress = !!response && response.status === 604;
    return {
        title: isNewSale
            ? 'Su venta ha sido guardada, pero hemos tenido un problema facturando su venta:'
            : 'Hemos tenido un problema facturando su venta:',
        mensaje: reason || (missingAddress ? ADDRESS_FALLBACK : CERTIFICATE_FALLBACK),
        informacionAdicional: '',
        action: missingAddress ? 'establishments' : 'certificate',
    };
}

// Lo que ve quien no puede editar Negocio, según `action`.
export function businessActionHint(action) {
    return action === 'establishments'
        ? 'Pídele a un administrador que complete la dirección del establecimiento en Negocio.'
        : 'Pídele a un administrador que revise la firma en Negocio.';
}
